import Component from '@glimmer/component';
import { helper } from '@ember/component/helper';
import { ensureSafeComponent } from '@embroider/util';

export default class IcLegacyTableRowComponent extends Component {
  componentClass = helper(function ([component, self], _) {
    return typeof component === 'string' ? ensureSafeComponent(component, self) : component;
  });
}
